<template>
  <div class="followtestdetail-child1">
             <el-form :inline="true" ref="form" :model="form"  @keyup.enter.native.prevent="enterSearchMember(form)" class="demo-form-inline toolbar" style="padding-bottom:0px;">
                <el-form-item label="老人姓名">
                    <el-select v-model="form.oldmanName"  clearable placeholder="请选择老人"  filterable>
                        <el-option
                            v-for="(item,index) in oldmanNameIdList"
                            :key="index"
                            :label="item.oldName"
                            :value="item.oldName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        :editable="false"
                        v-model="form.timevalue"
                        unlink-panels
                        type="daterange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions"
                        clearable
                       >
                    </el-date-picker>
                </el-form-item>
                 <el-form-item>
                    <el-button type="primary" icon='el-icon-search' plain @click="onSubmit">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="danger" icon='el-icon-delete' plain @click="onClear">清空选择</el-button>
                </el-form-item>
                 <el-form-item>
                    <el-button type="warning" icon ='el-icon-back' plain @click="goBack">返回</el-button>
                </el-form-item>
            </el-form>
            <div
            v-loading="loading"
            element-loading-text="拼命加载中......"
            >
            <!-- 封装的 i-table组件-->
            <div class="table-page">
                <i-table :list="list"
                    @handleSelectionChange="handleSelectionChange"
                    :options="options"
                    :columns="columns"
                    :operates="operates"
                >
                </i-table>
            </div>
          <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              layout="total, prev, pager, next"
              :total="totalDataNumber"
			    :page-size="pageSize"
              align="center"
               class="fenye">
          </el-pagination>
      </div>
  </div>
</template>

<script>
import iTable from "@/components/iTable.vue";
export default {
    data() {
        return {
            //table数据
            list: [],//返回的结果集合
            currentPage:1, //初始页
            pageNum: 1,//页码
            pageSize: 8,//每页显示的条数
            deviceId:this.$route.query.id,//设备id
            oldmanId:'',//老人id
            oldmanNameIdList:[],//老人姓名和Id
            oldIdCard:[],//老人身份证
            oldmanList:[],//老人所有信息列表
            totalDataNumber: 0,//数据的总数,
            loading:"",//加载数据中
            form: {
                oldmanName:"",//老人姓名
                timevalue:"",//时间
            },
            options: {
                stripe: true, // 是否为斑马纹 table
                //loading: true, // 是否添加表格loading加载动画
                highlightCurrentRow: true, // 是否支持当前行高亮显示
                mutiSelect: false, // 是否支持列表项选中功能
            }, // table 的参数

            columns: [
            {
                prop: 'oldmanName',
                label: '老人姓名',
                align: 'center',
            },
            {
                prop: 'boxygen',
                label: '血氧浓度',
                align: 'center',
                // formatter: (row, column, cellValue) => {
                // return row.deviceType===4 ? `<span style="white-space: nowrap;color: dodgerblue;">智能网关</span>` : " "
                // }
            },
            {
                prop: 'status',
                label: '血氧状态',
                align: 'center',
            },
            {
                prop: 'createdTime',
                label: '测量时间',
                align: 'center',
            },
            ], // 需要展示的列

            operates: {
            width: 400,
            fixed: 'right',
            offset:20,
            list: []
            },// 列操作按钮
            //1. element-ui 日期选择器如何限制只能选择一个月，超过一个月不能选择，也就是在选定起始日期时，只能向后面选择30天，同时不能选择超过今天的日期
            //2.  只限制未来日期
            pickerMinDate: '',
            dateRange: [],
            pickerOptions: {
                //1
                // onPick: ({ maxDate, minDate }) => {
                //     this.pickerMinDate = minDate.getTime()
                //     if (maxDate) {
                //     this.pickerMinDate = ''
                //     }
                // },
                // disabledDate: (time) => {
                //     if (this.pickerMinDate !== '') {
                //     const day30 = (30 - 1) * 24 * 3600 * 1000
                //     let maxTime = this.pickerMinDate + day30
                //     if (maxTime > new Date()) {
                //         maxTime = new Date()
                //     }
                //     return time.getTime() > maxTime
                //     }
                //     return time.getTime() > Date.now()
                // }
                //2种
                disabledDate: (time) => {
                    return time.getTime() > Date.now()
                }
            }
        }
    },
    methods: {
        // 选中行
        handleSelectionChange (val) {
            console.log('val:', val)
        },

        // 修改table tr行的背景色
        tableRowStyle({ row, rowIndex }) {
            if(rowIndex %2==0){
                 return 'background-color: #fff'
            }else{
                 return 'background-color: #f9f9f9'
            }

        },
        //查询
        onSubmit() {
            console.log('submit!');
             this.getTableData();
        },

        //键盘事件  enter回车查询
        enterSearchMember(form){
            this.getTableData();
        },

        // 修改table header的背景色
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #bee1f4;color:#fff;font-weight: 500;'
            }
        },
        //清空
        onClear(){
            this
            this.form.oldmanName="";//清空选择的信息
            this.form.timevalue="";
        },
        //返回
        goBack(){
            this.$router.go(-1);
        },
        getTableData() {
            let param = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                deviceId :this.deviceId,
                oldmanId:this.oldmanId,
                timevalue:this.form.timevalue,
                oldmanName:this.form.oldmanName,
            }
            if(this.form.timevalue){
                // param['startQueryTime'] = this.form.timevalue[0];
                // param['endQueryTime'] = this.form.timevalue[1];

                param['startQueryTime'] = this.form.timevalue[0];
                param['endQueryTime'] = this.form.timevalue[1].substring(0,10)+" 23:59:59";
            }else{

            }
            console.log(param)
            this.loading = true;
            this.$postJson('dmc/follow/queryDmcFollowDataBpressureListWithPage', param)
            .then((res) => {
                console.log(res)
                //判断是否有数据
                if(res.result.list.length!=0){
                    this.pageSize=res.result.pageSize;
                    this.currentPage=res.result.pageNum;
                    this.totalDataNumber=res.result.total*1;
                    this.list=res.result.list;
                    setTimeout(()=>{
                        this.loading = false;
                    },500)
                }else{
                    this.list=[];
                    this.totalDataNumber=0;
                    setTimeout(()=>{
                        this.loading=false;
                    },3000)
                }
            })
        } ,

         //获取所有老人信息
        getOldmanList(){
            let param={
                pageNo : "0",
                pageSize :"0",
                oldName : "",
                sex :"",
            }
            this.$postJson('omc/OldmanCheckIn/showAll', param)
            .then((res) => {
                console.log(res);
                this.oldmanList=res.result.list;
                var arroldNameId=[];
                var arroldIdCard=[];
                var objoldNameId={}
                res.result.list.forEach((item,index)=>{
                    objoldNameId={
                        oldName:item.oldName,
                        oldmanId:item.oldmanId
                    }
                    arroldNameId.push(objoldNameId)
                    arroldIdCard.push(item.oldIdCard);
                })
                console.log(arroldNameId,"OOOOOOOOO")
                 this.oldmanNameIdList=Object.assign([],arroldNameId);//深拷贝记录
                this.oldIdCard=Object.assign([],arroldIdCard);//深拷贝记录
                console.log(this.oldmanNameIdList);
                console.log(this.oldIdCard);
                console.log(res.result.list);
            })
        },

        // 初始页currentPage、初始每页数据数pagesize和数据data
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
             // 改变每页显示的条数
            this.PageSize=val
            this.getTableData();
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNum = val;
            this.getTableData();
      }
    },
    watch:{
         currentPage(oldV, newV) {
            console.log(oldV, newV);

        }
    },
    created(){
        this.getTableData();
        this.getOldmanList();
          //键盘事件 查询
        var _self = this;
        document.onkeydown = function(e){
            if(window.event == undefined){
                var key = e.keyCode;
            }else{
                var key = window.event.keyCode;
            }
            if(key == 13){
                _self.enterSearchMember('form');
            }
        }
    },
    mounted(){

    },
    components:{iTable},
  }
</script>
<style lang="scss" scoped>
    .followtestdetail-child1{
      // border:1px solid #e0e0e0;
    }
    .el-table{
      padding:0 20px 10px 15px;
    }
    .fenye{
      margin:30px 0;

    }
  .el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
  .el-table__body tr.current-row>td {
	background-color: #ffec8b;
}

</style>
